<template>
  <v-dialog v-model="showChangeCreditCardDialog" max-width="564px">
    <v-card v-if="showChangeCreditCardDialog">
      <v-card-title class="primary white--text">
        <h3 class="headline">
          {{ $t('texts.changeCreditCard') }}
        </h3>
        <v-spacer/>
        <v-btn
          text small fab
          @click="closeDialog()"
        >
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="stripeEnvIsTesting">
        <v-alert :value="true" type="info">
          Test Credit Card Switzerland: 4000007560000009 12/20 123<br>
          More: <a href="https://stripe.com/docs/testing" style="color: white" target="_blank">https://stripe.com/docs/testing</a>
        </v-alert>
      </v-card-text>
      <v-card-text>
        <form data-vv-scope="form-1">
          <card class='stripe-card'
            :class='{ complete }'
            :stripe='stripePublishableKey'
            :options='stripeOptions'
            ref='card'
            @change='complete = $event.complete'
          />
          <span
            v-show="this.cardError"
            class="help is-danger error--text input-group__error"
          >
            {{ this.cardError }}
          </span>
        </form>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-btn
          color="primary" text
          @click="closeDialog()"
        >
          {{ $t('texts.cancel') }}
        </v-btn>
        <v-spacer/>
        <v-btn
          color="secondary"
          @click="getCardToken()"
          :disabled="buttonLoading || changeCreditCardPending"
          :loading="buttonLoading || changeCreditCardPending"
        >
          {{ $t('texts.updateCreditCard') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { Card, createToken } from 'vue-stripe-elements-plus';
import { stripePublishableKey } from '@/config';

const { mapState: mapSubscriptionState, mapActions: mapSubscriptionActions } = createNamespacedHelpers('subscription');
const { mapActions: mapMessageActions } = createNamespacedHelpers('messages');

export default {
  name: 'EditCreditCardDialog',
  components: {
    Card,
  },
  data() {
    return {
      showChangeCreditCardDialog: false,
      buttonLoading: false,
      stripePublishableKey,
      complete: false,
      stripeOptions: {
        style: {
          base: {
            fontSize: '16px',
          },
        },
      },
      form: {
        company_id: null,
        credit_card_token: '',
      },
      cardError: null,
    };
  },
  $_veeValidate: {
    validator: 'new',
  },
  mounted() {
    this.$eventBus.$on('show-change-credit-card-dialog', (companyId) => {
      this.reset();
      this.form.company_id = companyId;
      this.showChangeCreditCardDialog = true;
    });
  },
  computed: {
    ...mapSubscriptionState([
      'changeCreditCardPending',
    ]),
    stripeEnvIsTesting() {
      return this.stripePublishableKey.substr(0, 7) === 'pk_test';
    },
  },
  methods: {
    ...mapSubscriptionActions([
      'changeCreditCard',
    ]),
    ...mapMessageActions([
      'showMessageValidateError',
    ]),
    reset() {
      this.form = {
        company_id: null,
        token: '',
      };
      // Reset stripe card
      this.$validator.reset();
    },
    closeDialog() {
      this.reset();
      this.$refs.card.clear();
      this.cardError = null;
      this.showChangeCreditCardDialog = false;
    },
    getCardToken() {
      this.buttonLoading = true;
      createToken().then((data) => {
        if (data.error) {
          this.cardError = this.$i18n.t('texts.creditcardInvalid');
          this.buttonLoading = false;
        } else {
          this.cardError = null;
          this.form.token = data.token.id;
          this.validateBeforeSubmit();
        }
      });
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.changeCreditCard(this.form)
            .then(() => {
              this.buttonLoading = false;
              this.$refs.card.clear();
              this.reset();
              this.showChangeCreditCardDialog = false;
            }).catch(() => {
              this.buttonLoading = false;
            });
        } else {
          this.showMessageValidateError();
        }
      });
    },
  },
};
</script>
